<!-- 动态tabs栏 -->
<template>
    <div>
        <div id="box">
            <div class="top">
                <div class="boxl">
                    <p>{{ sheng }}</p>
                    <span type="text" @click="toggS">切换</span>
                </div>
                <div class="boxr">
                    <p>{{ sheng }} <span>{{ activeName }}</span></p>
                </div>
            </div>
            <div class="tabs1">
                <!-- 切换市级 -->
                <el-tabs tab-position="left" @tab-click="shiTab" v-model="activeName">
                    <el-tab-pane ref="addressTabs" v-for="(item, index) in shi" :key="index" :label="item.label"
                        :name="item.label">
                        <!-- 切换县区 -->
                        <div class="tabs2">
                            <el-tabs v-model="activeName2" @tab-click="quTab">
                                <el-tab-pane v-for=" (item, index) in qu" :key="index" :name="item.label"
                                    :label="item.label">
                                    <div class="addressMin">
                                        <el-radio-group size="small" v-model="typeRideo" @input="radioInput">
                                            <el-radio-button v-for="(item1, index1) in rideoList" :key="index1"
                                                :label="item1"></el-radio-button>
                                        </el-radio-group>
                                        <div class="packageBox">
                                            <div class="item" v-for="item in addressList" :key="item.id"
                                                @click="goSearch(item)">
                                                {{ item.name }}<span>{{ item.countNumber }}</span></div>
                                        </div>
                                    </div>
                                </el-tab-pane>

                            </el-tabs>



                            <!-- 分页 -->
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                :current-page="queryObj.current" :page-size="queryObj.size"
                                layout="total, sizes, prev, pager, next, jumper" :total="total">
                            </el-pagination>

                        </div>
                    </el-tab-pane>

                </el-tabs>



            </div>
        </div>

        <!-- 切换景区对话框 -->
        <el-dialog title="选择省/自治区" center :visible.sync="dialogVisible" width="40%">
            <p class="dialogText">当前选择是 <span>{{ sheng }}</span> </p>
            <div class="shengSpan">
                <span @click="choseSheng(item)" v-for="(item, index) in city" :key="index">{{
                    item.label
                }}</span>
            </div>

        </el-dialog>

    </div>
</template>

<script>
import chinaCity from '@/utils/chinaCity'
import { lookAreaCountList } from '@/api/userHome.js'
export default {
    props: {
        address: {
            type: Array,
        },

    },
    components: {},
    data() {
        return {
            rideoList: ['景区/景点', '酒店/民宿', '美食/餐厅', '非遗/文化', '活动/会议', '其他'],
            typeRideo: '景区/景点',//单选绑定值
            city: chinaCity,//所有城市
            sheng: '浙江省',// 默认浙江省
            activeName: '杭州市',//默认市
            shi: [],//对应省的市级
            qu: [],//县区数组
            activeName2: '上城区',//默认选中区县
            dialogVisible: false,//切换省对话框
            queryObj: {
                size: 30,
                current: 1,
                category: '',//分类
                address: '',//地址
            },
            addressList: [],
            total: 0
        }
    },
    computed: {},
    watch: {},
    methods: {
        // 点击切换按钮
        toggS() {
            this.dialogVisible = true
        },
        // 点击对话框里切换省
        choseSheng(item) {
            // 省改变切换市
            this.sheng = item.label
            // 再循环找出对应省的所有市
            this.city.forEach(item => {
                if (item.label == this.sheng) {
                    this.shi = item.children
                }
            })

            this.activeName = this.shi[0].label//省切换默认选中第一个（省会）
            // 调用方法选出对应市的县区
            this.loopThree(this.activeName)
            this.activeName2 = this.qu[0].label//省切换默认选中第一个区县
            this.getAddress() //请求景区
            this.dialogVisible = false
        },


        // 市切换
        shiTab() {
            // console.log(this.activeName);
            // 调用方法筛选出对应市的县区
            this.loopThree(this.activeName)
            this.activeName2 = this.qu[0].label//省切换默认选中第一个区县
            // console.log(this.qu);
            this.getAddress() //请求景区
        },

        //区切换
        quTab() {
            // console.log('发请求', this.activeName2);
            this.getAddress() //请求景区
        },


        // 分类单选变化
        radioInput(val) {
            // console.log('发请求', val);
            this.getAddress() //请求景区
        },


        // 获取景点请求
        async getAddress() {
            this.queryObj.address = `${this.sheng}/${this.activeName}/${this.activeName2}`,
                this.queryObj.category = this.typeRideo
            // console.log(this.queryObj);
            const res = await lookAreaCountList(this.queryObj)
            this.addressList = res.data.records
            this.total = res.data.total
            // console.log(this.addressList);
            // console.log(`${this.sheng}/${this.activeName}/${this.activeName2}`, this.typeRideo);
        },

        //筛选出对应县区方法
        // 把对应市传进来
        loopThree(data) {
            this.shi.forEach(item => {
                if (item.label == data) {
                    this.qu = item.children
                }
            })
            // console.log(this.qu);

            this.getAddress()
        },


        // 点击景区搜索
        goSearch(item) {
            // return console.log(item);
            let { href } = this.$router.resolve({
                path: '/photoSearchResule',
                query: {
                    lookAreaId: item.id,
                    type: 'img'
                }
            })

            window.open(href, '_blank')
        },


        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.queryObj.size = val
            this.getAddress()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.queryObj.current = val
            this.getAddress()
        },



    },
    created() {
        // this.sheng = this.address ? this.address : '浙江省'
        // console.log(this.address)
        if (this.address && this.address.length == 1) {
            this.sheng = this.address[0] //如果长度等于1省就等于第一项
            // 根据省查找第一个市（因为影像馆地址只有省）
            this.city.forEach(item => {
                if (item.label == this.address[0]) {
                    this.activeName = item.children[0].label
                    //根据是查处区
                    item.children.forEach(item1 => {
                        if (item1.label == this.activeName) {
                            this.activeName2 = item1.children[0].label
                        }
                    })
                }
            })
        } else if (this.address && this.address.length == 2) {
            this.sheng = this.address[0]
            this.activeName = this.address[1]
            this.city.forEach(item => {
                if (item.label == this.address[0]) {
                    item.children.forEach(item1 => {
                        if (item1.label == this.address[1]) {
                            this.activeName2 = item1.children[0].label
                        }
                    })
                }
            })
        } else if (this.address && this.address.length == 3) {
            this.sheng = this.address[0]
            this.activeName = this.address[1]
            this.activeName2 = this.address[2]
        } else {
            this.sheng = '浙江省'
            this.activeName = '杭州市'
            this.activeName2 = '上城区'
        }

        // 进页面根据省找出市
        // console.log(this.sheng);
        this.city.forEach(item => {
            if (item.label == this.sheng) {
                this.shi = item.children
            }
        })
        // 调用方法筛选出对应市的区县
        this.loopThree(this.activeName)
        this.getAddress()
    }
}
</script> 

<style scoped lang='scss'>
// // 移动端
// @media screen and (min-width: 375px) and (max-width: 1456px) {
//     #box {
//         width: 100% !important;
//     }

// }


.dialogText {
    margin-bottom: 10px;

    span {
        color: #db3a3b;
    }
}

#box {
    // box-shadow: 0 0.15625vw 0.41667vw rgba(173, 172, 173, 0.2);
    border: 1px solid #eee;
    border-radius: 8px;
    height: 863px;
    width: 100%;
    background-color: #fff;
    margin: 0 auto;

    // 头部
    .top {
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;

        .boxl {
            // padding-top: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-right: 2px;
            border-right: 2px solid #E8E8E8;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
            height: 100%;
            width: 220px;
            background: #F7F8FA;
            position: relative;

            span {
                position: absolute;
                bottom: -10px;
                z-index: 777;
                margin-top: 3px;
                border: 1px solid #db3a3b;
                border-radius: 3px;
                padding: 0 3px;
                font-size: 14px;
                font-weight: normal;
                color: #db3a3b;
                cursor: pointer;
                transition: all .3s;

                &:hover {
                    font-weight: bold;
                }
            }
        }

        .boxr {
            padding-left: 22px;
            height: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            font-size: 24px;
            font-weight: normal;
            background: #F7F8FA;

            span {
                margin-left: 10px;
                font-size: 16px;
                color: #858585;
            }
        }
    }

    // 左边切换栏
    .tabs1 {

        /deep/ .el-tabs__nav-prev {
            top: 15px;
        }

        /deep/ .el-tabs {
            height: 780px;
        }

        /deep/ .el-tabs__item {
            line-height: 50px;
            height: 50px;
        }

        /deep/ .el-tabs--left .el-tabs__nav.is-left {
            margin-top: 20px;
        }


        /deep/ .el-tabs--left .el-tabs__header.is-left {
            margin-right: 0 !important;
            // padding-top: 30px;
            background-color: #F7F8FA;
            color: #000;
        }

        /deep/ .el-tabs--left .el-tabs__item.is-left {
            width: 220px;
            text-align: center;

            &:nth-child(0) {
                margin-top: 20px !important;
            }
        }

        /deep/ .el-tabs__item.is-active {
            // background-color: #fff;
            // color: #000;
            background-color: none;
            color: #DC3B3B;
        }
    }

    /deep/ .el-pagination {
        background-color: none;
        width: 100%;
        position: absolute !important;
        bottom: 0px;
    }

    // 头部切换栏
    .tabs2 {
        margin-left: 3px;
        position: relative;

        /deep/ .el-tabs__nav-scroll {
            width: 95%;
            margin: 0 auto;
        }



        /deep/ .el-tabs__nav-prev {
            top: 3px;
            left: 25px;
        }

        /deep/ .el-tabs__nav-next {
            top: 3px;
            right: 18px;
        }

        /deep/ .el-tabs--top .el-tabs__header.is-top {
            background-color: #F7F8FA;
            font-size: 16px;
        }



        /deep/ .el-tabs__item.is-active {
            background-color: none;
            color: #DC3B3B;
            font-weight: bold;
            border-radius: 5px;
        }

        /deep/ .el-tabs--top .el-tabs__item.is-top {
            &:nth-child(2) {
                // padding-left: 18px;
            }
        }

        /deep/ .el-tabs--top .el-tabs__item.is-top {
            &:last-child {
                // padding-right: 18px !important;
            }
        }


    }


    // 景区内容盒子
    .addressMin {
        padding-left: 20px;
        margin-top: 15px;

        .packageBox {
            margin-top: 40px;
            width: 100%;
            display: flex;
            flex-wrap: wrap;

            .item {
                padding: 15px 0 15px 0;
                font-size: 14px;
                width: 35%;
                transition: all .3s;
                cursor: pointer;

                &:nth-child(3n) {
                    width: 30%;
                }

                &:hover {
                    // text-decoration: underline;
                    font-weight: bold;
                }

                span {
                    margin-left: 5px;
                    color: #898989
                }
            }
        }
    }

}

// 省选择对话框
.shengSpan {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 15px;

    span {
        margin-bottom: 20px;
        margin-right: 10px;
        border: 1px solid #ccc;
        padding: 5px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
            background-color: rgba($color: #c2baba, $alpha: 1.0);
            transform: scale(1.02)
        }
    }

    ;
}

/deep/ .el-pagination .el-pager .active {
    color: #db3a3b !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addressTabs.vue